// Un cuadro de un video LOCAL (el archivo que el usuario acaba de elegir), como JPEG, para
// usarlo de miniatura — ADR-2026-10-20-el-video-adjunto-se-ve-y-se-reproduce.
//
// Se lee del archivo en memoria (object URL), así que no depende de la red ni de CORS. El
// cuadro se toma un poco después del arranque y no en 0: muchos videos abren en negro o con
// un fundido. Nunca tira: `null` si el navegador no puede decodificar el video (un HEVC en
// Chrome, por ejemplo) o si tarda más que `esperaMs`.

/** Lado mayor de la miniatura: alcanza para un chip de 92 px y para la tarjeta de Crear. */
const LADO_MAYOR = 480;

export function cuadroDeVideo(archivo: Blob, esperaMs = 8_000): Promise<Blob | null> {
  return new Promise((resolver) => {
    if (typeof document === 'undefined') {
      resolver(null);
      return;
    }
    const url = URL.createObjectURL(archivo);
    const video = document.createElement('video');
    let listo = false;
    const terminar = (blob: Blob | null) => {
      if (listo) return;
      listo = true;
      window.clearTimeout(reloj);
      video.removeAttribute('src');
      try {
        video.load();
      } catch {
        /* noop */
      }
      URL.revokeObjectURL(url);
      resolver(blob);
    };
    const reloj = window.setTimeout(() => terminar(null), esperaMs);
    video.muted = true;
    video.playsInline = true;
    video.preload = 'auto';
    video.onloadedmetadata = () => {
      const d = Number.isFinite(video.duration) ? video.duration : 0;
      // Medio segundo, o el 10 % en un video muy corto.
      video.currentTime = d > 0 ? Math.min(0.5, d * 0.1) : 0;
    };
    video.onseeked = () => {
      const { videoWidth: w, videoHeight: h } = video;
      if (!(w > 0 && h > 0)) {
        terminar(null);
        return;
      }
      const escala = Math.min(1, LADO_MAYOR / Math.max(w, h));
      const canvas = document.createElement('canvas');
      canvas.width = Math.round(w * escala);
      canvas.height = Math.round(h * escala);
      const ctx = canvas.getContext('2d');
      if (!ctx) {
        terminar(null);
        return;
      }
      try {
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        canvas.toBlob((b) => terminar(b), 'image/jpeg', 0.82);
      } catch {
        terminar(null);
      }
    };
    video.onerror = () => terminar(null);
    video.src = url;
  });
}
